import React from 'react';
import BaseInput from '../Base/BaseInput';
import { Location } from '../../models/LocationModel';
import {
  finalizeFormTextField,
  sanitizeFormTextField,
} from '../../utils/textInputSanitize';
import './LocationForm.css';

interface Props {
  value: Location;
  onChange: (c: Location) => void;
  error?: string | null;
  fieldErrors?: Record<string, string>;
}

const LocationForm: React.FC<Props> = ({ value, onChange, fieldErrors = {} }) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    onChange({ ...value, [name]: sanitizeFormTextField(name, v) });
  };

  const handleBlur = (e: React.FocusEvent<HTMLInputElement>) => {
    const { name, value: v } = e.target;
    const next = finalizeFormTextField(name, v);
    if (next !== (value as any)[name]) {
      onChange({ ...value, [name]: next });
    }
  };

  return (
    <div className="location-form">
      <BaseInput
        label="Nombre de la ubicación"
        name="name"
        value={value.name ?? ''}
        onChange={handleChange}
        onBlur={handleBlur}
        required
        autoFocus
        maxLength={120}
        error={fieldErrors.name}
      />
    </div>
  );
};

export default LocationForm;
